import instance from "@/services/api";

export const packageEntryAPI = {
  async getPresetKitTypes() {
    return await instance()
      .get("/preset/preset_material/preset_kit/read/")
      .then((res) => res?.data);
  },

  async getRoughFinishingList(presetKitId, placementTypeId, workSetId) {
    const params = { preset_kit_id: presetKitId };
    if (placementTypeId) params.placement_type_id = placementTypeId;
    if (workSetId) params.work_set_id = workSetId;

    return await instance()
      .get("/preset/preset_material/read/", { params })
      .then((res) => res?.data);
  },

  async getPlacementTypesList(presetKitId) {
    return await instance()
      .get("/preset/preset_material/placement_types/read/", {
        params: { preset_kit_id: presetKitId },
      })
      .then((res) => res?.data);
  },

  async getWorkSetsList(presetKitId) {
    return await instance()
      .get("/preset/preset_material/work_set/read/", {
        params: { preset_kit_id: presetKitId },
      })
      .then((res) => res?.data);
  },

  async createRoughFinishing(data) {
    return await instance()
      .post("/preset/preset_material/create/", data)
      .then((res) => res?.data);
  },

  async updateRoughFinishing(id, data) {
    return await instance()
      .put(`/preset/preset_material/update/${id}/`, data)
      .then((res) => res?.data);
  },

  async deleteRoughFinishing(id) {
    return await instance()
      .delete(`/preset/preset_material/delete/${id}/`)
      .then((res) => res?.data);
  },

  async getScreedList(params = {}) {
    return await instance()
      .get("/preset/screed/read/", { params })
      .then((res) => res?.data);
  },

  async createScreed(data) {
    return await instance()
      .post("/preset/screed/create/", data)
      .then((res) => res?.data);
  },

  async updateScreed(id, data) {
    return await instance()
      .put(`/preset/screed/update/${id}/`, data)
      .then((res) => res?.data);
  },

  async deleteScreed(id) {
    return await instance()
      .delete(`/preset/preset_material/screed/delete/${id}/`)
      .then((res) => res?.data);
  },

  async getUnits() {
    return await instance()
      .get("/preset/preset_material/unit/read/")
      .then((res) => res?.data);
  },

  async createWorkSet(data) {
    return await instance()
      .post("/preset/preset_material/work_set/add/", data)
      .then((res) => res?.data);
  },

  async getMaterialSets(material_id) {
    return await instance()
      .get("/preset/preset_material/material_set_name/read/", {
        params: { material_id },
      })
      .then((res) => res?.data);
  },
  async getSetInfo(material_set_id) {
    return await instance()
      .get("/preset/preset_material/material_set/info/", {
        params: { material_set_id },
      })
      .then((res) => res?.data);
  },

  async createMaterialSet(data) {
    return await instance()
      .post("/preset/preset_material/material_set_item/add/", data)
      .then((res) => res?.data);
  },

  async searchMaterials(data, signal) {
    return await instance()
      .post("/preset/preset_material/material/get/", data, { signal })
      .then((res) => res?.data);
  },

  async addPackageEntry(data) {
    return await instance()
      .post("/preset/preset_material/preset_material_kit/add/", data)
      .then((res) => res?.data);
  },

  async deletePackageEntry(data) {
    return await instance()
      .delete("/preset/preset_material/preset_material_kit/delete/", { data })
      .then((res) => res?.data);
  },
  async updPackageEntry(body) {
    return await instance()
      .post("/preset/preset_material/preset_kit_item/upd/", body)
      .then((res) => res?.data);
  },
  async getPackagePurchaseTypes() {
    return await instance()
      .get(`/preset/preset_material/purchase_types/read/`)
      .then((res) => res?.data);
  },
  async getPackageMaterials(preset_kit_id) {
    return await instance()
      .get(`/preset/preset_material/materials/${preset_kit_id}/read/`)
      .then((res) => res?.data);
  },
  async updPackageMaterial(body) {
    return await instance()
      .post("/preset/preset_material/materials/upd/", body)
      .then((res) => res?.data);
  },
  async getConstructivesList(params) {
    return await instance()
      .get("/handbook/work_set/read/", { params })
      .then((res) => res?.data);
  },
  async getCompanyList() {
    return await instance()
      .get("/common/companies/read/")
      .then((res) => res?.data);
  },
  async getMainProvidersList() {
    return await instance()
      .get("/common/contractor_mains/read/")
      .then((res) => res?.data);
  },
  async getConstructivesPriceList(body) {
    return await instance()
      .post("/handbook/work_set/price_history/", body)
      .then((res) => res?.data);
  },
  async deleteConstructivesPrice(contractor_work_set_tariff_id) {
    return await instance()
      .delete(`/handbook/work_set/price/${contractor_work_set_tariff_id}/delete/`)
      .then((res) => res?.data);
  },
  async addConstructivesPrice(body) {
    return await instance()
      .post("/handbook/work_set/price/add/", body)
      .then((res) => res?.data);
  },
  async updConstructivesPrice(body) {
    return await instance()
      .post(`/handbook/work_set/price/update/`, body)
      .then((res) => res?.data);
  },

  async addConstructive(body) {
    return await instance()
      .post(`/handbook/work_set/cws/add/`, body)
      .then((res) => res?.data);
  },
  async updConstructive(body) {
    return await instance()
      .post(`/handbook/work_set/cws/update/`, body)
      .then((res) => res?.data);
  },
  async getConstructiveList() {
    return await instance()
      .get(`/common/work_sets/read/`)
      .then((res) => res?.data);
  },
  async getGoupConstructiveList() {
    return await instance()
      .get(`/common/work_set_check_groups/read/`)
      .then((res) => res?.data);
  },
  async getGroupConstructive(work_set_check_group_id) {
    return await instance()
      .get(`/common/work_set_check_groups/get/${work_set_check_group_id}/`)
      .then((res) => res?.data);
  },
  async addGroupConstructive(body) {
    return await instance()
      .post(`/common/work_set_check_groups/upd/`, body)
      .then((res) => res?.data);
  },
  async removeConstructiveFromProvider(contractor_work_set_id, params) {
    return await instance()
      .delete(`/handbook/work_set/cws/${contractor_work_set_id}/delete/`, { params })
      .then((res) => res?.data);
  },
  async getPresetTypes() {
    return await instance()
      .get("/preset/preset_material/preset_types/read/")
      .then((res) => res?.data);
  },
  async getSbsInagroKonstruktiv() {
    return await instance()
      .get("/preset/preset_material/sbs_inagro_konstruktiv/read/")
      .then((res) => res?.data);
  },
  async createPresetKit(data) {
    return await instance()
      .post("/preset/preset_material/preset/add/", data)
      .then((res) => res?.data);
  },
  async createPlacementType(data) {
    return await instance()
      .post("/preset/preset_material/placement_type/add/", data)
      .then((res) => res?.data);
  },
  async getAllPlacementTypes() {
    return await instance()
      .get("/project/common/placement_types/read/")
      .then((res) => res?.data);
  },
};
